import { useEffect } from "react";

const PAGE_SEO = {
  home: {
    en: { title: "ICON Trading Co. | Industrial Supplies Dammam, Saudi Arabia", desc: "Premier industrial supplies in Dammam, KSA. Gasket supplier Saudi Arabia, rubber products KSA, sealing solutions & comprehensive industrial materials." },
    ar: { title: "شركة أيكون التجارية | توريدات صناعية الدمام، السعودية", desc: "توريدات صناعية رائدة في الدمام. موردي الجوانات بالسعودية، منتجات المطاط، وحلول الإحكام والمواد الصناعية الشاملة." },
  },
  about: {
    en: { title: "About Us | ICON Trading Co. — Industrial Supply Dammam KSA", desc: "ICON Trading Co. is a premier industrial supply powerhouse in Dammam, Eastern Province — rubber products, sealing solutions and industrial materials." },
    ar: { title: "من نحن | شركة أيكون التجارية — توريدات صناعية الدمام", desc: "شركة أيكون التجارية قوة رائدة في التوريدات الصناعية بالدمام والمنطقة الشرقية." },
  },
  products: {
    en: { title: "Products | Gaskets, Rubber & Industrial Materials — ICON Trading", desc: "Rubber sheets, gaskets, engineering plastics, caster wheels, belts, bearings & industrial mesh. Gasket supplier Saudi Arabia, rubber products KSA." },
    ar: { title: "المنتجات | جوانات ومطاط ومواد صناعية — أيكون التجارية", desc: "ألواح مطاط، جوانات، بلاستيك هندسي، عجلات تحميل، سيور، رولمان بلي وشبك صناعي. موردي الجوانات بالسعودية." },
  },
  vision: {
    en: { title: "Vision & Industries | ICON Trading Co. — Eastern Province KSA", desc: "Serving oil & gas, construction, mining, manufacturing, water & desalination and renewable energy across Saudi Arabia." },
    ar: { title: "الرؤية والقطاعات | شركة أيكون التجارية", desc: "نخدم النفط والغاز والإنشاءات والتعدين والتصنيع والمياه والتحلية والطاقة المتجددة بالمملكة." },
  },
  contact: {
    en: { title: "Contact | ICON Trading Co. — Industrial Supplies Dammam", desc: "Get an itemised quotation. Download our catalogue. Industrial supplies Dammam · توريدات صناعية الدمام." },
    ar: { title: "تواصل معنا | شركة أيكون التجارية — توريدات صناعية الدمام", desc: "احصل على عرض سعر مفصّل وحمّل الكتالوج. توريدات صناعية الدمام." },
  },
};

export default function SEO({ page, lang }) {
  useEffect(() => {
    const data = (PAGE_SEO[page] && PAGE_SEO[page][lang]) || PAGE_SEO.home.en;
    document.title = data.title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", data.desc);
  }, [page, lang]);
  return null;
}
